import { useContext, useState } from "react";
import SearchFormContent from "../../../components/view/flight/domestic/search-form-content";
import { LocaleContext } from "../../../routing/LangRouter";

function DomesticFlightSearch() {
    const { locale } = useContext(LocaleContext);
    const [requestFlag, setRequestFlag] = useState(false);
    const [uid, setUid] = useState();
    
    return (
        <SearchFormContent
            requestFlag={requestFlag}
            setRequestFlag={setRequestFlag}
            flightRoute={`/${locale}/domestic-flight`}
            setUid={setUid}
        />
    );
}

export default DomesticFlightSearch;
